import axios from "axios";
import moment from 'moment';
import Chart from '@/components/base/charts/ChartVentas.vue'
import {mapState} from 'vuex';
import imprimir from '@/components/base/ImprimirCompra.vue'

export default {
  data() {
    return {
      dialog: false,
      menu1: false,
      comprobanteModal: 0,
      search: "",
      ventas: [],
      distribucion: [],
      ventasUnicas: [],
      allData: [],
      modoChart: "bar",
      headers: [
        { text: "#", value: 'index', sortable: false },
        //{ text: "Referencia", value: "referencia", sortable: false },
        { text: "Artículo", value: "articulo", sortable: true },
        { text: "Cantidad", value: "cantidad", sortable: true },
        // { text: "Serie Comprobante", value: "serie_comprobante", sortable: true },
        // { text: "Número Comprobante", value: "num_comprobante", sortable: false },
        { text: "Unidad", value: "unidad", sortable: true },
        //{ text: "Creado", value: "fecha", sortable: false },
      ],
      imprimir: {
        articulo: "",
        cantidad: "",
        unidad: "",
      },
      date: new Date().toISOString().substr(0, 10),
      date_distribution: new Date().toISOString().substr(0, 10),
      dateFormatted: moment(new Date()).format("L"),
      items:['Articulo','Unidad'],
      itemSelect:'Unidad'
    };
  },
  created() {
    this.listar();
    moment.locale("es")
  },
  components: {
    Chart, imprimir
  },
  computed: {
    ...mapState('usuarioNamespace',['token', 'usuario']),
  },
  methods: {
    changeDate($event) {
      this.dateFormatted = moment($event).format("L");
    },
    mostrarComprobante(mtipo) {
      this.$refs.imprimir.dialog = true;
      this.$refs.imprimir.tipo = mtipo;
      this.$refs.imprimir.ordenarLista( this.itemSelect )
    },
    listar() {
      let me = this;
      let token = this.token;
      let header = { Token: token };
      let configuracion = { headers: header };
      axios
        .get("venta/queComprar", configuracion)
        .then(function (response) {

          me.allData = response.data
          let f = 0
          let h = 0
          //recorro todas las ventas
          response.data.forEach(element => {
            //le cambio el formato a cada fecha
            let fecha = moment(element.entregaAt).format('LL')
            let today = moment(new Date()).format('LL')
            //recorro la lista detalles dentro de cada venta
            if( fecha === today ){
              element.detalles.forEach(detalle => {
  
                if ( element.negocio == 1 ) {
                  let existe = false
                  //recorro las ventas
                  me.ventas.forEach(table => {
                    //Si existe en la tabla, solo suma las cantidades
                    if (table.articulo == detalle.articulo && table.unidad == detalle.unidad ) {
                      existe = true;
                      table.cantidad = (detalle.cantidad + table.cantidad)
                    }
                  });
                  if (!existe) {
                    f++
                    me.ventas.push({
                      index: f,
                      referencia: element._id,
                      articulo: detalle.articulo,
                      cantidad: detalle.cantidad,
                      serie_comprobante: element.serie_comprobante,
                      num_comprobante: element.num_comprobante,
                      unidad:detalle.unidad,
                      fecha: fecha
                    })
                  }
                }
                if( element.negocio != 1){
                  let existe = false
                  me.distribucion.forEach(table => {
                    //Si existe en la tabla, solo suma las cantidades
                    if (table.articulo == detalle.articulo && table.unidad == detalle.unidad ) {
                      existe = true;
                      table.cantidad = (detalle.cantidad + table.cantidad)
                    }
                  });
                  if (!existe) {
                    h++
                    me.distribucion.push({
                      index: h,
                      referencia: element._id,
                      articulo: detalle.articulo,
                      cantidad: detalle.cantidad,
                      serie_comprobante: element.serie_comprobante,
                      num_comprobante: element.num_comprobante,
                      unidad:detalle.unidad,
                      fecha: fecha
                    })  
                  }
                }
              });
            }
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  watch: {
    //detectar el cambio en date_distribution
    date_distribution: function (date_select) {
      // vaciamos el array para que no se muestre como valores repetidos
      this.distribucion = []
      
      let i = 0
      this.allData.forEach(element => {
        //le damos un  formato a la fecha que viene del api para compararlo con la fecha seleccionada
        let f = moment(element.entregaAt).format('YYYY-MM-DD')
        //let f = moment(element.createdAt).format('YYYY-MM-DD')
        if (date_select == f) {
          
          let fecha = moment(element.entregaAt).format('LL')

          element.detalles.forEach(detalle => {

            let existe = false
            this.distribucion.forEach(table => {
              //recorremos los datos de distrubcion que son los que se mostraran en la tabla
              // si el valor existe le suma la cantidad e iguala existe a true
              //para que no lo agregue de nuevo a distribucion
              if (table.articulo == detalle.articulo && table.unidad == detalle.unidad ) {
                existe = true;
                table.cantidad = (detalle.cantidad + table.cantidad)
              }
            });
            // si existe es falso agrega el dato a la variable distribucion
            if (!existe) {
                if( element.negocio != 1){
                  i++
                  this.distribucion.push({
                    index: i,
                    referencia: element._id,
                    articulo: detalle.articulo,
                    cantidad: detalle.cantidad,
                    serie_comprobante: element.serie_comprobante,
                    num_comprobante: element.num_comprobante,
                    unidad:detalle.unidad,
                    fecha: fecha
                  })
                }
              
            }
          });
        }
      });
    },

    //detectar el cambio en date_distribution
    date: function (date_select) {
      // vaciamos el array para que no se muestre como valores repetidos
      this.ventas = []
      
      let i = 0
      this.allData.forEach(element => {
        //le damos un  formato a la fecha que viene del api para compararlo con la fecha seleccionada
        let f = moment(element.entregaAt).format('YYYY-MM-DD')
        //let f = moment(element.createdAt).format('YYYY-MM-DD')
        if (date_select == f) {
          
          let fecha = moment(element.entregaAt).format('LL')

          element.detalles.forEach(detalle => {

            let existe = false
            this.ventas.forEach(table => {
              //recorremos los datos de distrubcion que son los que se mostraran en la tabla
              // si el valor existe le suma la cantidad e iguala existe a true
              //para que no lo agregue de nuevo a distribucion
              
              if (table.articulo == detalle.articulo && table.unidad == detalle.unidad ) {
                existe = true;
                table.cantidad = (detalle.cantidad + table.cantidad)
              }
            });
            // si existe es falso agrega el dato a la variable distribucion
            if (!existe) {
              if( element.negocio == 1 ){
                i++
                this.ventas.push({
                  index: i,
                  referencia: element._id,
                  articulo: detalle.articulo,
                  cantidad: detalle.cantidad,
                  serie_comprobante: element.serie_comprobante,
                  num_comprobante: element.num_comprobante,
                  unidad:detalle.unidad,
                  fecha: fecha
                })
              }
            }
          });
        }
      });
    }
  }
};